import kyWithSentry from './kyWithSentry';

/**
 * Simple ky with Sentry GET by provided url
 * @param string - url
 */
const getByUrl = <T>(url: string): Promise<T> =>
  kyWithSentry.get(url).json<T>();

export default getByUrl;
